import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
// import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../ReporteCobranza/Actions/GetContainer";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../../Finanzas/Actions/GetContainer";
import FechaInput from "../../CreditoyCobranza/ReporteCobranza/Helper/FechaInput";
import { EsquemasSelect } from "../Cotizaciones/EsquemaSelect";
import { LineaSelect } from "./LineaSelect";
import { CultivoSelect } from "./CultivoSelect";

const FiltroEmbudoVentas = ({
    onExecute,
    boxState,
    onBoxChange,
    cargarfiltros = true
}) => {
    // console.log(permisos)
    const [openModal, setOpenModal] = useState(false);
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    const defaultState = {
        esquema: -999,
        faseSelect: [],
        fases: [
            { value: 'PR', label: 'Promoción', checked: false },
            { value: 'IN', label: 'Interés', checked: false },
            { value: 'NE', label: 'Negociación', checked: false },
            { value: 'CE', label: 'Cerrada', checked: false },
            { value: 'FM', label: 'Facturar Mes', checked: false },
            { value: 'FS', label: 'Facturar Semana', checked: false },
            { value: 'NC', label: 'No Compró', checked: false },
            { value: 'VP', label: 'Venta Perdida', checked: false },
            { value: 'VN', label: 'Vendido', checked: false },
        ],
        ejercicio: currentYear,
        periodo: today.getMonth() + 1,
        fechaInicio: new Date(`${currentYear}-${currentMonth}-01`).toISOString().split('T')[0],
        fechaFin: today.toISOString().split('T')[0],
        linea: 0,
        cultivo: 'Consolidado'
    };

    const [state, setState] = useState(defaultState);

    // console.log(state)
    const {
        data,
        adr,
        sucursal,
        departamento,
        linea,
        fase,
        fases,
        fechaInicio,
        fechaFin,
        comparacion,
        objecion,
        rango
    } = state;
    const onOpenModal = () => {
        const container = document.getElementById("mdlFiltros-modal");
        if (!container) return;
        if (openModal) {
            container.style.display = "flex";
            setOpenModal(false);
        } else {
            container.style.display = "none";
            setOpenModal(true);
        }
    };

    useEffect(() => {
        // onClose();
        if (cargarfiltros)
            GetASD()
                .then((res) => {
                    setState({
                        ...state,
                        data: res,
                    });
                    onBoxChange("pv", {
                        adr: GroupByProps(res, ["idadr", "adr"]),
                        sucursal: [],
                        departamento: [],
                    });
                })
                .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        let newadr = GroupByPropCheck(data, ["idadr", "adr"]);
        let newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
        let newdepartamento = GroupByPropCheck(
            data,
            ["iddepartamento", "departamento"],
            false
        );

        setState((prev) => ({
            ...prev,
            adr: newadr,
            sucursal: newsucursal,
            departamento: newdepartamento,
        }));
    }, [data]);

    const onCargar = () => {
        if (
            state.fechaInicio === undefined ||
            state.fechaInicio === null ||
            state.fechaInicio === ""
        ) {
            Swal.fire(
                "COTIZACIONES",
                "Favor de seleccionar la fecha de inicio",
                "warning"
            );
            return;
        }
        if (
            state.fechaFin === undefined ||
            state.fechaFin === null ||
            state.fechaFin === ""
        ) {
            Swal.fire(
                "COTIZACIONES",
                "Favor de seleccionar la fecha fin",
                "warning"
            );
            return;
        }
        if (
            state.fechaInicio > state.fechaFin
        ) {
            Swal.fire(
                "COTIZACIONES",
                "La fecha de inicio no puede ser mayor a la fecha fin.",
                "warning"
            );
            return;
        }
        onOpenModal();
        onExecute(state.fechaInicio, state.fechaFin, state.esquema, state.linea, state.cultivo, state.faseSelect)
            .then((result) => {
            })
            .catch((error) => {
                Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
            });
    };

    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };

    const selectedClick = ({ target }, index) => {
        switch (target.name) {
            case "chk-adr":
                var newarray = adr;
                newarray[index].checked = target.checked;

                var newarrarsucursal = [];
                var newarraydepartamento = [];
                var adrActive = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
                        newarrarsucursal = newarrarsucursal.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "idsucursal",
                                "sucursal",
                            ])
                        );
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: adrActive,
                    sucursal: [],
                    departamento: [],
                });
                setState({
                    ...state,
                    adr: newarray,
                    sucursal:
                        newarrarsucursal.length == 0
                            ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
                            : GroupByPropCheck(
                                newarrarsucursal,
                                ["idsucursal", "sucursal"],
                                false
                            ),
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-sucursal":
                var newarray = sucursal;
                newarray[index].checked = target.checked;

                var newarraydepartamento = [];
                var sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [
                            ...sucursalactiva,
                            { idsucursal: item.idsucursal, sucursal: item.sucursal },
                        ];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: sucursalactiva,
                    departamento: [],
                });
                setState({
                    ...state,
                    sucursal: newarray,
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-fase":
                var newFases = state.fases;
                newFases[index].checked = target.checked;

                var fasesActivas = [];
                newFases.forEach((item) => {
                    if (item.checked) {
                        fasesActivas = [...fasesActivas, item.value];
                    }
                });

                onBoxChange("faseSelect", fasesActivas);

                setState({
                    ...state,
                    fases: newFases,
                    faseSelect: fasesActivas,
                });
                break;
            default:
                var newarray = departamento;
                var departamentoactivo = [];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        departamentoactivo = [
                            ...departamentoactivo,
                            {
                                iddepartamento: item.iddepartamento,
                                departamento: item.departamento,
                            },
                        ];
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: boxState.pv.sucursal,
                    departamento: departamentoactivo,
                });
                setState({
                    ...state,
                    departamento: newarray,
                });
                break;
        }
    };

    const onChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };

    return (
        <div className="filtros-pedidos-facturados">
            <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </div>
            <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
                <PlantillaScreen
                    titulo={`Filtro`}
                    className_main={1}
                    className={`modal-filtro-resumen-cartera-mensual`}
                >
                    <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
                        X
                    </div>
                    <div className="modal-filtro-resumen-cartera-mensual-container">
                        <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
                            <div className="filtro-tiempo-tipo">
                                <div className="filtro-group">
                                    <label>Fecha Inicio</label>
                                    <FechaInput
                                        name="fechaInicio"
                                        value={state.fechaInicio}
                                        onChange={onChange}
                                    />
                                    <label>Fecha Fin</label>
                                    <FechaInput
                                        name="fechaFin"
                                        value={state.fechaFin}
                                        onChange={onChange}
                                    />
                                    <label>Esquema</label>
                                    <EsquemasSelect
                                        name="esquema"
                                        value={state.esquema}
                                        onChange={onChange}
                                    />
                                    <label>Linea</label>
                                    <LineaSelect
                                        name="linea"
                                        value={state.linea}
                                        onChange={onChange}
                                    />
                                    <label>Cultivo</label>
                                    <CultivoSelect
                                        name="cultivo"
                                        value={state.cultivo}
                                        onChange={onChange}
                                    />
                                </div>
                                <div
                                    className="mdlFiltros-modal-acciones-guardar"
                                    onClick={onCargar}
                                >
                                    Cargar
                                </div>
                            </div>
                            <div className="filtro-fase">
                                <div className="title-fase">FASE</div>
                                {state.fases.map((item, index) => (
                                    <div key={`${item.value}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-fase"
                                            className="my-checkbox"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.value}
                                        />
                                        <label onClick={labelclick}>{item.label}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="mdlFiltros-modal-acciones">
                        </div>
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};

export default FiltroEmbudoVentas;
